class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    // Cache summary element to avoid repeated queries
    this.summaryElement = this.mainDetailsToggle.querySelector('summary');

    // Cache animations after first access
    this.animations = null;
    this.animationsCached = false;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this), { passive: true });
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this), { passive: true });
  }

  onFocusOut() {
    // Replace setTimeout with requestAnimationFrame to avoid blocking
    requestAnimationFrame(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    // Cache animations on first access
    if (!this.animationsCached) {
      try {
        this.animations = this.content ? this.content.getAnimations() : [];
        this.animationsCached = true;
      } catch (e) {
        // Fallback if getAnimations fails
        this.animations = [];
        this.animationsCached = true;
      }
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      // Use requestAnimationFrame for animation control
      requestAnimationFrame(() => {
        if (this.animations && this.animations.length > 0) {
          for (const animation of this.animations) {
            animation.play();
          }
        }
      });
    } else {
      // Cancel animations immediately when closing
      if (this.animations && this.animations.length > 0) {
        for (const animation of this.animations) {
          animation.cancel();
        }
      }
    }
  }

  close() {
    // Batch DOM updates with requestAnimationFrame
    requestAnimationFrame(() => {
      this.mainDetailsToggle.removeAttribute('open');
      if (this.summaryElement) {
        this.summaryElement.setAttribute('aria-expanded', false);
      }
    });
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    // Cache header element
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Check if property already set before expensive getBoundingClientRect
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;

    // Use requestAnimationFrame for style updates to batch with browser rendering
    requestAnimationFrame(() => {
      const headerBottom = Math.floor(this.header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--header-bottom-position-desktop', `${headerBottom}px`);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
